import React from "react";
import styles from "./styles.module.scss";
import { Oval } from "react-loader-spinner";

const Button = ({
  variant = "primary",
  children,
  onClick,
  disabled,
  icon,
  fullWidth = false,
  isLoading = false,
  size = "medium",
  condensedX = false,
  ...props
}) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${disabled ? styles.disabled : ""} ${icon ? styles.withIcon : ""} ${fullWidth ? styles.fullWidth : ""} ${styles[size]} ${condensedX ? styles.condensedX : ""}`}
      onClick={!disabled && !isLoading ? onClick : undefined}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFF"
          ariaLabel="oval-loading"
          strokeWidth="6"
          strokeWidthSecondary="6"
        />
      )}
      {icon}
      {children}
    </button>
  );
};

export default Button;
